/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        window.currentTpl = getCurrentTpl();
        contactForm();
        google.maps.event.addDomListener(window, 'load', initialize);
        setInterval(fadeExpertises, 4000);
        $('#bgs-bs').fillsize( '> img.header-img' );

        //jQuery for page scrolling feature - requires jQuery Easing plugin
        $(function() {
            $('#menu-menu-principal a[href^="/#"], #cadenas a').bind('click', function(event) {
                var $anchor = $(this);
                var href = $anchor.attr('href');
                var selector = href;
                if(selector.substr(0,1) === "/"){
                  selector = selector.substr(1);
                }
                $('html, body').stop().animate({
                    scrollTop: $(selector).offset().top
                }, 1500, 'easeInOutExpo');
                event.preventDefault();
            });
        });
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // Menu
  var $body = $('body');
  $body.on('click',function(e){
    var $openNavParents = $(e.target).parents('.openNav');
    var $headerBannerParents = $(e.target).parents('header.banner');
    var isOpenNav = $(e.target).hasClass('openNav') || ($openNavParents && $openNavParents.length);
    var isHeader = $(e.target).hasClass('banner') || ($headerBannerParents && $headerBannerParents.length);
    if(isOpenNav){
      $('body').toggleClass('menu-open');
    } else {
      if(!isHeader && $('body').hasClass('menu-open')){
        $('body').removeClass('menu-open');
      }
    }
  });
  var $containers = $(".content_persp");
  $(window).scroll(function() {
    var basepoint = $(document).scrollTop() + window.innerHeight / 2;
    $containers.each(function(){
      var vanishingpoint = basepoint - $(this).offset().top;
      $(this).css({'-webkit-perspective-origin': ' 100% ' + vanishingpoint + 'px'});
    });
  });

  function contactForm() {
    // trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
    if (!String.prototype.trim) {
      (function() {
        // Make sure we trim BOM and NBSP
        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        String.prototype.trim = function() {
          return this.replace(rtrim, '');
        };
      })();
    }

    [].slice.call( document.querySelectorAll( '.sae input, .sae textarea' ) ).forEach( function( inputEl ) {
      // in case the input is already filled..
      if( inputEl.value.trim() !== '' ) {
        inputEl.addClass('input--filled');
      }

      // events:
      inputEl.addEventListener( 'focus', onInputFocus );
      inputEl.addEventListener( 'blur', onInputBlur );
    } );

    function onInputFocus( ev ) {
      $(ev.target).parent().parent('.sae').addClass('input--filled');
    }

    function onInputBlur( ev ) {
      if( ev.target.value.trim() === '' ) {
        $(ev.target).parent().parent('.sae').removeClass('input--filled');
      }
    }

    $(document).on('change', '.btn-file :file', function() {
        var input = $(this),
            numFiles = input.get(0).files ? input.get(0).files.length : 1,
            label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
        input.trigger('fileselect', [numFiles, label]);
        $('.btn-file > p').html(label);
    });

    $('.btn-file > p').click(function() {
      $('#cv').click();
    });
  }

  // GMaps
  function initialize() {
    var styles = [
      {
        "featureType": "all",
        "elementType": "geometry.fill",
        "stylers": [
          { "hue": "#0e88f9" }
        ]
      },
      {
        "featureType": "water",
        "stylers": [
          { "color": "#162c5d" }
        ]
      },{
        "featureType": "road",
        "stylers": [
          { "visibility": "off" }
        ]
      },{
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
          { "visibility": "on" },
          { "color": "#162c5d" }
        ]
      },{
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        "stylers": [
          { "weight": 2 },
          { "color": "#162c5d" }
        ]
      },{
        "elementType": "labels.text.stroke",
        "stylers": [
          { "visibility": "on" },
          { "color": "#e1edf8" }
        ]
      },{
        "featureType": "administrative.province",
        "elementType": "geometry.stroke",
        "stylers": [
          { "visibility": "off" }
        ]
      }
    ];

    // Create a new StyledMapType object, passing it the array of styles,
    // as well as the name to be displayed on the map type control.
    var styledMap = new google.maps.StyledMapType(styles,{name: "Virelec"}), isDraggable;

    // Si on est sur un iPhone ou iPad on bloque la faculté de dragger la Map
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
     isDraggable = false;
    } else {
      isDraggable = true;
    }

    var mapOptions = {
      zoom: 6,
      center: new google.maps.LatLng(47.816841, 6.381111),
      draggable: isDraggable,
      scrollwheel: false,
      mapTypeControlOptions: {
        mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
      }
    };
    var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
    //Associate the styled map with the MapTypeId and set it to display.
    map.mapTypes.set('map_style', styledMap);
    map.setMapTypeId('map_style');

    setMarkers(map, elements);
  }

  var elements = [
    ['<div class="adresse_marker"><h4>Bourgogne (Siège social)</h4><h5>8 rue de la Renouille BP 84<br />21604 LONGVIC CEDEX<br />Tél. : 03 80 60 07 37<br />Fax : 03 80 60 07 38</h5></div>', 47.287835, 5.036505, 1]
  ];

  function addMarker(infowindow, marker, location, map) {
    return function() {
      infoBubble.close();
      if (!infoBubble.isOpen()) {
        infoBubble.setContent(location[0]);
        infoBubble.setMinWidth(400);
        infoBubble.setMinHeight(150);
        infoBubble.setBackgroundColor(currentTpl.hexa);
        // infoBubble.setShadowStyle(shadowStyle);
        // infoBubble.setPadding(padding);
        // infoBubble.setBorderRadius(borderRadius);
        // infoBubble.setBorderWidth(borderWidth);
        infoBubble.setBorderColor('transparent');
        infoBubble.setMaxWidth(500);
        infoBubble.setMaxHeight(150);
        // infoBubble.setMinWidth(minWidth);
        // infoBubble.setMinHeight(minHeight);
        // infoBubble.setArrowSize(arrowSize);
        // infoBubble.setArrowPosition(arrowPosition);
        // infoBubble.setArrowStyle(arrowStyle);
        infoBubble.setCloseSrc('app/themes/custom/assets/images/close_bubble.png');
        infoBubble.open(map, marker);
      }
    };
  }

  function setMarkers(map, locations) {
    // Add markers to the map

    // Marker sizes are expressed as a Size of X,Y
    // where the origin of the image (0,0) is located
    // in the top left of the image.

    // Origins, anchor positions and coordinates of the marker
    // increase in the X direction to the right and in
    // the Y direction down.
    var image = {
      url: 'app/themes/custom/assets/images/flag_' + currentTpl.color + '.png',
      // This marker is 20 pixels wide by 32 pixels tall.
      size: new google.maps.Size(69, 83),
      // The origin for this image is 0,0.
      origin: new google.maps.Point(0, 0),
      // The anchor for this image is the base of the flagpole at 0,32.
      anchor: new google.maps.Point(35, 83)
    };
    // Shapes define the clickable region of the icon.
    // The type defines an HTML &lt;area&gt; element 'poly' which
    // traces out a polygon as a series of X,Y points. The final
    // coordinate closes the poly by connecting to the first
    // coordinate.
    var shape = {
        coords: [0, 0, 0, 83, 83, 83, 83, 0],
        type: 'poly'
    };
    var infowindow = new google.maps.InfoWindow();
    for (var i = 0; i < locations.length; i++) {
      var element = locations[i];
      var myLatLng = new google.maps.LatLng(element[1], element[2]);
      var marker = new google.maps.Marker({
          position: myLatLng,
          map: map,
          icon: image,
          shape: shape,
          title: element[0],
          zIndex: element[3]
      });

      infoBubble = new InfoBubble({
        maxWidth: 300,
        backgroundColor: 'rgb(57,57,57)',
      });

      google.maps.event.addListener(marker, 'click', (addMarker(infowindow, marker, locations[i], map)));
    }
  }

  function fadeExpertises(){
    $(".altern").each(function() {
      $(this).toggleClass('fade');
    });
  }

  // On select change Contact status form
  $( "select[name='your-subject']" ).change(function() {
    var $select = $(this).val();
    if($select === "Contact") {
      $('.btn-file').hide();
    } else {
     $('.btn-file').show();
    }
  });

  // Accordéon actif :: sécurités
  $('a[data-toggle="collapse"]').click(function() {
    var $currentSide = $(this).closest('.half-page').attr('id'), $initBg;
    var $panelHeading = $(this).closest('.panel-heading');

    if($currentSide === "securite") {
      $initBg = "bgc-blue";
    } else {
      $initBg = "bgc-skyblue";
    }
    $('#' + $currentSide).find('.panel-heading').removeClass('bgc-white').addClass($initBg);
    var $expandedBefore = $(this).attr('aria-expanded');
    console.log($expandedBefore);
    if($expandedBefore === 'false') {
      $panelHeading.removeClass($initBg).addClass('bgc-white');
    }
  });

  // Get current template
  function getCurrentTpl() {
    var colors = {};
    if($('body').hasClass('automatisme')) {
      colors.color = "green";
      colors.hexa = "#94c02d";
    } else {
      colors.color = "orange";
      colors.hexa = "#C84D1F";
    }
    return colors;
  }

})(jQuery); // Fully reference jQuery after this point.
